import {
  ADD_APPOINTMENT,
  ADD_BARBER,
  ADD_CHARGE,
  ADD_DISCOUNT,
  ADD_ITEM,
  POPULATE,
  REMOVE_BARBER,
  REMOVE_DISCOUNT,
  REMOVE_ITEM,
  RESET,
  ADD_GIFT_CARD,
  UPDATE_GIFT_CARD,
  SET_ITEM_QUANTITY,
  SET_MEMBERSHIP,
  SET_PRESERVE_ORDER_CUSTOMER,
} from './constants';
import { mapAppointment } from '../helpers';
import { ITEM_TYPE } from '../constants';

export const resetOrder = () => ({
  type: RESET,
});

export const addBarber = id => ({
  type: ADD_BARBER,
  payload: id,
});

export const removeBarber = id => ({
  type: REMOVE_BARBER,
  payload: id,
});

const addItem = type => (barberId, item) => ({
  type: ADD_ITEM,
  payload: {
    barberId,
    item: {
      ...item,
      type,
    },
  },
});

export const addProduct = addItem(ITEM_TYPE.product);
export const addService = addItem(ITEM_TYPE.service);
export const addAppointmentItem = addItem(ITEM_TYPE.appointment);
export const addCustomChargeItem = addItem(ITEM_TYPE.charge);
export const addGiftCardItem = addItem(ITEM_TYPE.giftCard);

export const addCustomCharge = payload => ({
  type: ADD_CHARGE,
  payload,
});

export const addGiftCard = payload => ({
  type: ADD_GIFT_CARD,
  payload,
});

export const updateGiftCard = payload => ({
  type: UPDATE_GIFT_CARD,
  payload,
});

export const addDiscount = ({ id }) => ({
  type: ADD_DISCOUNT,
  payload: id,
});

export const removeDiscount = id => ({
  type: REMOVE_DISCOUNT,
  payload: id,
});

export const addAppointment = (barberId, item) => ({
  type: ADD_APPOINTMENT,
  payload: {
    barberId,
    item: mapAppointment(item),
  },
});

export const setItemQuantity = (barberId, item, quantity) => ({
  type: SET_ITEM_QUANTITY,
  payload: {
    barberId,
    item,
    quantity,
  },
});

export const removeItem = (barberId, id) => ({
  type: REMOVE_ITEM,
  payload: {
    barberId,
    id,
  },
});

export const populateOrder = ({ items, discounts, membership }) => ({
  type: POPULATE,
  payload: { items, discounts, membership },
});

export const setMembership = membership => ({
  type: SET_MEMBERSHIP,
  payload: membership,
});

export const resetMembership = () => ({
  type: SET_MEMBERSHIP,
  payload: null,
});

export const setPreserveOrderCustomer = preserveOrderCustomer => ({
  type: SET_PRESERVE_ORDER_CUSTOMER,
  payload: preserveOrderCustomer,
});
